import React from 'react'
import '../Cardpage.css'
import petacc from '../Images/petaccessban.jpg'
function PetAccess() {
  return (
    <>
    <div className='cardpagediv'>
      <h3 className='cardpagehead'>Pet Accessories</h3>
      <img src={petacc} className='w-100 imgbanner' alt="" />
    </div>
    <p className='cardpagepara1 ms-2 me-2'>
      We have a huge verieties of pet accessories in our store.
    </p>
    <h5 className='cardpagehead5'>
      Major Pet Accessories we have:
    </h5>
    <ul>
      <li>Leeshes and Chains</li>
      <li>Collars</li>
      <li>Chock Chains</li>
      <li>Food Bowls</li>
      <li>Pet Combs</li>
      <li>Pet Nail clippers</li>
      <li>Pet Toys</li>
      <li>Calcium Bones</li>
      <li>Muzzle masks</li>
    </ul>
    <p className='ms-2 pagebott'>We will provide any  Pet Accessories based on your pet's requirements. </p>
    </>
  )
}

export default PetAccess